<template>
  <div  class="upInputs">
    <div class="mb-2 relative h-20">
      <zt-input
        data-vs-input="old-password"
        class="mb-1"
        v-model="value.oldPassword"
        maxlength="32"
        label="Contraseña actual"
        outlined
        type="password"
        color="primary"
      />
    </div>
    <div class="mb-10 relative h-20">
      <zt-tooltip
        position="right"
        :clickable="true"
        color="dark-300"
        outlined
        :shadow="true"
      >
        <div slot="body" class="p-3">
          <PasswordPolicie :pass-policies="passwordPolicies" />
        </div>
        <zt-input
          data-vs-input="expires-password"
          class="mb-1"
          v-model="value.password"
          maxlength="32"
          label="Contraseña"
          outlined
          v-validate="{ required: true, min: 8, regex: /^.*[0-9]{1,}.*$/ }"
          name="password"
          type="password"
          :color="!passwordIsValid ? 'danger' : 'primary'"
        />
      </zt-tooltip>
      <div
        class="ml-4 text-xs text-zt-danger"
        v-show="errors.items[0] && errors.items[0].rule === 'required'"
      >
        {{ $t('message.passwordExpired.password_validation.required') }}
      </div>
      <div
        class="ml-4 text-xs text-zt-danger"
        v-show="errors.items[0] && errors.items[0].rule === 'min'"
      >
        {{
          $t('message.passwordExpired.password_validation.min_character_rule')
        }}
      </div>
      <div
        class="ml-4 text-xs text-zt-danger"
        v-show="errors.items[0] && errors.items[0].rule === 'regex'"
      >
        {{ $t('message.passwordExpired.password_validation.min_number_rule') }}
      </div>
      <div class="ml-4 text-xs">
        {{
          $t('message.passwordExpired.password_validation.min_character_info')
        }}
      </div>
    </div>
    <div class="mb-6 relative h-20">
      <zt-input
        data-vs-input="expires-password-repeat"
        v-model="value.rePassword"
        maxlength="32"
        label="Repetir contraseña"
        outlined
        type="password"
        :color="value.password !== value.rePassword ? 'danger' : 'primary'"
      />
      <span
        v-show="value.password !== value.rePassword && value.rePassword !== ''"
        class="ml-4 text-xs text-zt-danger"
        >{{
          $t('message.passwordExpired.password_validation.no_match_pass')
        }}</span
      >
      <div class="ml-4 text-xs">
        {{
          $t('message.passwordExpired.password_validation.min_character_info')
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { useWindowResize } from '@zetech/ui-elements'
import PasswordPolicie from '@/components/generics/PasswordPolicie.vue'

export default {
  name: 'ztPasswordExpiredFields',
  components: {
    PasswordPolicie
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        oldPassword: '',
        password: '',
        rePassword: ''
      })
    },
    passwordPolicies: {
      type: Object,
      default: () => {}
    },
    passwordIsValid: {
      type: Boolean,
      default: true
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {
      isInvalid: null,
      windowSize: useWindowResize(this)
    }
  },

  computed: {
    isMobile() {
      return this.windowSize.width < 1024
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip-body {
  color: #575757;
  .tooltip-title {
    color: #03a9f4;
  }
}

.text-xs {
  line-height: 1.5;
}

.upInputs {
  margin-top: -15px;
}
</style>
